export default __webpack_public_path__ + "static/media/about-us.3b45a24e.jpg";